export default __webpack_public_path__ + "static/media/patent5.c2310aca.png";